import { useEffect, useState } from "react";

/**
 * Auto-hide helper: true while the pointer is near a screen edge. Reveal is a
 * thin strip (slide toward the edge to summon the panel); once revealed it
 * stays while the pointer remains within the panel zone — hysteresis, so the
 * panel doesn't flap at the boundary.
 */
export function useEdgeReveal(side: "left" | "right", active: boolean, revealPx = 30, keepPx = 400) {
  const [near, setNear] = useState(false);
  useEffect(() => {
    if (!active) { setNear(false); return; }
    const move = (e: PointerEvent) => {
      const d = side === "left" ? e.clientX : window.innerWidth - e.clientX;
      setNear((cur) => (cur ? d < keepPx : d < revealPx));
    };
    window.addEventListener("pointermove", move);
    return () => window.removeEventListener("pointermove", move);
  }, [side, active, revealPx, keepPx]);
  return near;
}
